import type { RoundingRuleValueModel } from '@/shared/generated'
import type { ErrorSchema } from '@/shared/tools/json-schema-utils'
import type { JSONSchemaType } from 'ajv'

import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { ErrorBoundary } from '@/shared/components/ErrorBoundary'

import { RoundingRulesFields } from './RoundingRulesFields'

export const RoundingRulesFiledController = ({
	name,
	shouldUnregister,
	defaultValue,
	...props
}: {
	name: string
	shouldUnregister?: boolean
	defaultValue?: RoundingRuleValueModel
	errorSchema?: ErrorSchema
	schema: JSONSchemaType<RoundingRuleValueModel[]>
}) => {
	const rules = useWatch({ name })
	const { control } = useFormContext()

	return (
		<Controller
			name={name}
			shouldUnregister={shouldUnregister}
			defaultValue={defaultValue}
			control={control}
			render={({ field, fieldState: { error } }) => (
				<ErrorBoundary>
					<RoundingRulesFields
						namePrefix={name}
						rules={rules || []}
						onChange={field.onChange}
						errorSchema={error}
						{...props}
					/>
				</ErrorBoundary>
			)}
		/>
	)
}
